// News.js
import React, { useState, useEffect, useCallback } from "react";
import NewsItem from "./NewsItem";
import InfiniteScroll from "react-infinite-scroll-component";
import '../News.css';

function News(props) {
  const [articles, setArticles] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [page, setPage] = useState(1);

  const API_KEY = '9a731a3291da8a53eceb4aa1e3dc3e08';

  const fetchNews = useCallback(async () => {
    try {
      const url = `https://gnews.io/api/v4/search?q=example&lang=en&country=us&max=10&apikey=${API_KEY}&page=${page}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const parsedData = await response.json();
      setArticles(parsedData.articles || []);
      setTotalResults(parsedData.totalArticles || 0);
    } catch (error) {
      console.error("Error fetching initial news data:", error);
    }
  }, [page, API_KEY]);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  const fetchData = async () => {
    try {
      const nextPage = page + 1;
      const url = `https://gnews.io/api/v4/search?q=example&lang=en&country=us&max=10&apikey=${API_KEY}&page=${nextPage}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const parsedData = await response.json();
      setArticles(prevArticles => prevArticles.concat(parsedData.articles || []));
      setPage(nextPage);
    } catch (error) {
      console.error("Error fetching paginated news data:", error);
    }
  };

  return (
    <div className="news-wrapper">
      <header className="news-header">
        <h1>Latest News</h1>
      </header>

      <InfiniteScroll
        dataLength={articles.length}
        next={fetchData}
        hasMore={articles.length < totalResults}
        loader={<div className="loader">Loading...</div>}
        endMessage={<div className="end-message">No more articles to load</div>}
      >
        <div className="news-container">
          <div className="featured-section">
            <div className="featured-content">
              <img 
                src="../main_logo.jpg" 
                alt="Featured Content" 
                className="featured-image"
              />
              <p className="featured-text">
                {/* Note: Inline scripts aren't recommended in React. Consider moving this to a separate component */}
                {/* For now, I'll leave it as a placeholder */}
                Stay updated
              </p>
            </div>
          </div>

          <div className="articles-grid">
            {articles.map((element, index) => (
              <NewsItem
                key={`${element.url}-${index}`} // More robust key
                sourceName={element.source.name}
                title={element.title}
                desc={element.description}
                imageURL={element.image || "placeholder.jpg"}
                newsUrl={element.url}
              />
            ))}
          </div>
        </div>
      </InfiniteScroll>
    </div>
  );
}

export default News;